import loadable from '@loadable/component';

// 懒加载组件
const ItemNewApplicationWithSelection = loadable(() => import('./itemNewApplicationWithSelection/ItemNewApplicationWithSelection'));

export const subRoutes = [
  {
    path: '/ItemNewApplicationWithSelection',
    component: ItemNewApplicationWithSelection
  }
];
